import { render, staticRenderFns } from "./AddPermission.vue?vue&type=template&id=5a82c4cb&scoped=true"
import script from "./AddPermission.vue?vue&type=script&lang=js"
export * from "./AddPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82c4cb",
  null
  
)

export default component.exports